import { PaginationTable } from '../../../common/components';

const WarehousesPagination = ({
  totalPages,
  totalCount,
  page,
  rowsPerPage,
  onPageChange,
  onRowsPerPageChange,
}) => (
  <PaginationTable
    totalPages={totalPages}
    totalCount={totalCount}
    page={page}
    rowsPerPage={rowsPerPage}
    onPageChange={onPageChange}
    onRowsPerPageChange={onRowsPerPageChange}
  />
);

export default WarehousesPagination;
